import { render, staticRenderFns } from "./SpecificApiComponent.vue?vue&type=template&id=5aa23c7a&scoped=true&"
import script from "./SpecificApiComponent.vue?vue&type=script&lang=js&"
export * from "./SpecificApiComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpecificApiComponent.vue?vue&type=style&index=0&id=5aa23c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa23c7a",
  null
  
)

export default component.exports